/* globals angular */
angular
  .module('mandaeApp')
  .factory('ClienteResource', function ($resource, URL, URLAPICLIENTE, PATH) {
    'use strict';
    return $resource(URL + PATH + '/customers/:customerId', {}, {
      ultimosEnderecos: {
        method: 'GET',
        url: URL + PATH + '/customers/:customerId/addresses/last',
        isArray: true,
        params: {
          customerId: '@customerId'
        }
      },
      getCartao: {
        method: 'GET',
        url: URL + PATH + '/customers/:customerId/paymentMethod',
        params: {
          customerId: '@customerId'
        }
      },
      criaCartao: {
        method: 'POST',
        url: URL + PATH + '/customers/:customerId/createPaymentMethod',
        params: {
          customerId: '@customerId'
        }
      },
      habilitaCartao: {
        params: {
          paymentId: '@paymentId',
          customerId: '@customerId'
        },
        method: 'GET',
        url: URL + PATH + '/customers/:customerId/enablePaymentMethod/:paymentId'
      },
      desabilitaCartao: {
        params: {
          paymentId: '@paymentId',
          customerId: '@customerId'
        },
        method: 'GET',
        url: URL + PATH + '/customers/:customerId/disablePaymentMethod/:paymentId'
      },
      gravarDocumentos: {
        params: {
          idCliente: '@idCliente'
        },
        method: 'PUT',
        url: URLAPICLIENTE + '/clientes/:idCliente/documentos'
      },
      gravarGastoMensal: {
        params: {
          idCliente: '@idCliente'
        },
        method: 'PUT',
        url: URLAPICLIENTE + '/clientes/:idCliente/gastoMensal'
      },
      gravarDadosContato: {
        params: {
          idCliente: '@idCliente'
        },
        method: 'PUT',
        url: URLAPICLIENTE + '/clientes/:idCliente/contato'
      },
      getProfile: {
        url: URLAPICLIENTE + '/clientes/:idCliente/',
        params: {
          idCliente: '@idCliente'
        },
      },
      criarContato: {
        method: 'PUT',
        url: URLAPICLIENTE + '/clientes/:clienteId/contatos',
        params: {
          clienteId: '@clienteId'
        }
      },
      editarContato: {
        method: 'POST',
        url: URLAPICLIENTE + '/clientes/:clienteId/contatos/:contatoId',
        params: {
          clienteId: '@clienteId',
          contatoId: '@contatoId'
        }
      },
      getContatos: {
        method: 'GET',
        isArray: true,
        url: URLAPICLIENTE + '/clientes/:clienteId/contatos',
        params: {
          clienteId: '@clienteId'
        }
      },
      removeContato: {
        method: 'DELETE',
        url: URLAPICLIENTE + '/clientes/:clienteId/contatos/:contatoId',
        params: {
          clienteId: '@clienteId',
          contatoId: '@contatoId'
        }
      },
      getPrefixos: {
        method: 'GET',
        url: URLAPICLIENTE + '/clientes/:clienteId/prefixos',
        params: {
          clienteId: '@clienteId'
        }
      },
      getAddresses: {
        method: 'GET',
        url: URLAPICLIENTE + '/clientes/:clientId/enderecos',
        isArray: true,
        params: {
          clientId: '@clientId'
        }
      },
      getFirstSteps: {
        method: 'GET',
        url: URLAPICLIENTE + '/clientes/:clienteId/primeiros-passos',
        params: {
          clienteId: '@clienteId'
        }
      }
    });
  });
